<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-customer-overview-panel-usage-per-customer" v-loading="loading" element-loading-text="Loading..." @mouseover="mouseover" @mouseout="mouseout">
    <wy-panel-header ref="panelHeader" :panelHeaderData="pannelData" :controller="module" :panelTitle="panelTitle" />
    <wy-panel-tabs :controller="module" :topSectionData="pannelData"/>
    <wy-panel-tab-section ref="tabSection" :controller="module" :panelId="panelId" :sectionData="sectionData" :legendData="legendData" />
  </div>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex';
  import WyCustomerUtils from '../utils/wy-customer-utils.js';
  import WyPanelHeader from '../../panel-views/wy-panel-header.vue';
  import WyPanelTabs from '../../panel-views/wy-panel-tabs.vue';
  import WyPanelTabSection from '../../panel-views/wy-panel-tab-section.vue';

  export default Vue.extend({
    name: 'wy-customer-overview-panel-usage-per-customer',
    props: ["controller"],
    components: { 
      'wy-panel-header': WyPanelHeader,
      'wy-panel-tabs': WyPanelTabs,
      'wy-panel-tab-section': WyPanelTabSection
    },

    data() {
      return {
        module: this,
        loading: false,
        templateData: {},
        rawData: {},
        pannelData: {},
        sectionData: {},
        lineChartData: {},
        panelId: 'usagePerCustomer',
        panelTitle: 'Usage per Customer',
        legendData: {},
        dataIndex: 0,
        dateRange: 'month'
      }
    },

    computed: {
      ...mapGetters(['dataModel', 'companyConfig']),
    },

    methods: {
      ...mapActions(['fetchUsagePerCustomer', 'prepareCustomerBehaviourViewByData']),

      async changeDateRange(dateRange) {
        this.dateRange = dateRange;
        this.controller.changeDateRange(dateRange, this.rawData, this.templateData, this);
      },

      mouseover() {
        this.$refs.panelHeader.$refs.settingSection.$el.classList.add("show");
      },
      mouseout(e) {
        if(e.toElement && (e.toElement._prevClass == "components-container" || e.toElement._prevClass == 'wy-performance-overview-page' || e.toElement._prevClass == 'el-main wy-container-main')) {
          this.$refs.panelHeader.$refs.settingSection.$refs.configureDropdown.hide();
        }
        this.$refs.panelHeader.$refs.settingSection.$el.classList.remove("show");
      },

      renderLegendData() {
        if(this.sectionData.lineChartData) {
          this.legendData['legends'] = this.sectionData.lineChartData.legends
        }
        if(this.sectionData.pieChartData) {
          this.legendData['legends'] = [];
          this.sectionData.columnChartData.legends.forEach((legend)=>{
            this.legendData['legends'].push(legend);
          })
          // // this.legendData['legends'].push('average conversations')
          // this.sectionData.pieChartData.legends = this.legendData['legends'];
          if(this.sectionData.lineChartData.legends && this.sectionData.lineChartData.legends.length > 0) {
            this.legendData['legends'].push(this.sectionData.lineChartData.legends[0])
          }
          this.sectionData.pieChartData.legends = this.legendData['legends'];
          let titleLegends = this.legendData['legends'].slice(0, -1)
          this.sectionData.pieChartData.title = this.sectionData.pieChartData.title + titleLegends.join(', ');
          let sectionData = JSON.parse(JSON.stringify(this.sectionData));
          this.sectionData = {};
          this.sectionData = sectionData;
          let total = 0;
          this.sectionData.pieChartData.values.forEach(item => {
            total += item;
          })
          this.sectionData.pieChartData.displayValue = total
        }
      },

      async handleFilterChange() {
        // this.overviewData = null
        if((!this.loading && this.dataModel.dateEnd) ||this.dataModel.dateEnd) {
          this.loading = true;
          this.rawData = await this.fetchUsagePerCustomer(this.controller.selection);
          // this.rawData = null;
          // this.rawData = WyCustomerUtils.getMockData().usagePerCustomer
          if(this.rawData && Object.keys(this.rawData).length > 0 && this.$refs.panelHeader) {
            this.templateData = WyCustomerUtils.getCustomerBehaviourUsagePerCustomerData();
            // this.dateRange = this.controller.setDefaultDateRange();
            // this.$refs.panelHeader.$refs.settingSection.selectedDateRange = this.dateRange;
            this.pannelData = await this.prepareCustomerBehaviourViewByData({viewBy: this.dateRange, rawData: this.rawData, templateData: this.templateData, companyConfig: this.companyConfig})
            this.sectionData = this.pannelData.data[this.dataIndex];
            if(this.$el.querySelector(".el-loading-mask")) {
              this.$el.querySelector(".el-loading-mask").style.display = 'none'
            }
            this.loading = false;
            this.renderLegendData();
            if(this.$refs.tabSection && this.$refs.tabSection.$refs.tabBottomSection) {
              setTimeout(() => {
                this.controller.refreshOverviewPanel(this, this.sectionData);
                this.$refs.tabSection.$refs.tabBottomSection.renderLegends();
              }, 300);
            }
          }
          else {
            this.loading = false;
            this.pannelData = {};
            this.sectionData = {};
          }
        }
      },
    },

    async created(){
      this.dateRange = this.controller.setDefaultDateRange();
      await this.handleFilterChange();
      // this.$el.classList.add("full-size");
    }
  });
</script>

<style lang="scss">
  .wy-customer-overview-panel-usage-per-customer {
    .el-loading-mask {
      height: 656px !important;
    }
  }
</style>